<template>
	<div>
		<div class="fixedSearch">
			<el-input size="small" :placeholder="$t('main.PleaseEnterContent')" v-model="queryOutline" clearable class="input-with-select">
				<el-button size="small" slot="append" icon="el-icon-search" @click="queryQuestionOutline"></el-button>
			</el-input>
		</div>
		<div class="fixedTabsIcon-box">
			<el-tooltip class="item" effect="light" :content="$t('main.copy')" placement="top"><i class="zxwj-iconfont zxwj-icon-fuzhi" @click="copyClick"></i></el-tooltip>
			<el-tooltip class="item" effect="light" :content="$t('main.paste')" placement="top">
				<i class="zxwj-iconfont zxwj-icon-niantie1" @click="pasteClick"></i>
			</el-tooltip>
		</div>
		<div class="fixedTabsThird">
			<div class="QuestionOutline">
				<el-tree 
					ref="tree" 
					:data="data" 
					:props="defaultProps" 
					:empty-text="$t('main.ThereIsCurrentlyNoDataAvailable')"
					:default-expand-all="true" 
					:highlight-current="true" 
					node-key="qid" 
					@node-click="nodeClick"
					draggable
					:allow-drag="allowDrag"
					:allow-drop="allowDrop"
					@node-drop="nodeDrop"
					>
					<span class="span-ellipsis" slot-scope="{ node, data }">
						{{ data.quesIndex || '' }}
						<span :title="node.label" v-html="node.label"></span>
					</span>
				</el-tree>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'QuestionOutline',
	components: {},
	props: {
		type: {
			type: String,
			default: ''
		},
		paper: {},
		activeQuesIndex: {
			type: Number,
			default: -1
		}
	},
	data() {
		return {
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				qid: 'qid'
			},
			queryOutline: '',
			questionCopy: {}, // 复制到的试题
			list: [],
		};
	},
	computed: {},
	watch: {
		list(newV) {
			this.data = [];
			if (this.type == 'ks') {
				this.getData([402, 404]);
			} else {
				this.getData(['26']);
			}
		},
	},
	created() {},
	methods: {
		queryQuestionOutline() {
			this.list = JSON.parse(JSON.stringify(this.paper.questionsList));
			if (this.queryOutline == '') {
				this.list = this.paper.questionsList;
			} else {
				this.list = this.filterList();
			}
		},
		filterList() {
			return this.list.filter(p => {
				return p.questionsName.indexOf(this.queryOutline) !== -1;
			});
		},
		
		// 复制 将当前试题复制到模板
		copyClick() {
			this.questionCopy = this.paper.questionsList[this.activeQuesIndex];
			if (this.questionCopy?.qid) {
				this.$message({
					message: this.$t('main.ReplicatingSuccess'),
					type: 'success'
				});
				console.log(this.questionCopy);
			} else {
				this.$message({
					message: this.$t('main.PleaseSelectTheTestQuestionFirst'),
					type: 'warning'
				});
			}
		},
		// 粘贴试题
		pasteClick() {
			if (this.questionCopy && this.questionCopy.qid) {
				this.paper.cancleEdit();
				this.paper.copyQuestion(this.questionCopy, this.activeQuesIndex);
				if (this.questionCopy?.qid) {
					this.$message({
						message: this.$t('main.ReplicatingSuccess'),
						type: 'success'
					});
					this.queryQuestionOutline()
				} else {
					this.$message({
						message: this.$t('main.ThereAreCurrentlyNoTestQuestionsToPaste'),
						type: 'warning'
					});
				}
			} else {
					this.$message({
						message: this.$t('main.ThereAreCurrentlyNoTestQuestionsToPaste'),
						type: 'warning'
					});
				}
		},
		allowDrag(draggingNode) {
			if (draggingNode.level == 2 && draggingNode.data.questionsTypeId != 501) {
				return true
			} else {
				return false
			}
		},
		allowDrop(draggingNode, dropNode, type) {
			
			const dragData = draggingNode.data; // 被拖拽节点的信息
			const dropData = dropNode.data;     // 目标位置节点的信息
			if ((dropNode.level == 2 && type == 'next') || (dropNode.level == 1 && type == 'inner')) {
				if ( (dragData.questionsTypeId == 600 && dropData.questionsTypeId == 501) ||
					(dragData.questionsTypeId != 600 && dropData.questionsTypeId != 600) ||
					(dragData.questionsTypeId != 600 && dropData.questionsTypeId == 501)
				){
					return true
				} else {
					return false
				}
			} else {
				return false
			}
		},
		nodeDrop() {
			const result = [];
			this.data.forEach(page => {
				result.push(page);
				if (page.children && page.children.length > 0) {
				page.children.forEach(question => {
					result.push(question);
				});
				}
			});
			this.changeQues(result)
		},
		
		// 大纲页面中试题重新排序 
		changeQues(list) {
			const qidToIndexMap = {};
			list.forEach((item, index) => {
				qidToIndexMap[item.qid] = index;
			});
			// 根据映射对第二个数组进行排序
			this.paper.questionsList.sort((a, b) => {
				const aIndex = qidToIndexMap[a.qid] !== undefined ? qidToIndexMap[a.qid] : Infinity;
				const bIndex = qidToIndexMap[b.qid] !== undefined ? qidToIndexMap[b.qid] : Infinity;
				return aIndex - bIndex;
			});
		},
		getData(typeArr) {
			if ((this.type == 'ks' && this.list.length > 0 && this.list[0].questionsTypeId != 402 && this.list[0].questionsTypeId != 404) || 
				(this.type == 'wj' && this.list.length > 0 && this.list[0].questionsTypeId != '26')) {
				this.data = [
					{
						children: [],
						label: `${this.$t('main.pageNumber')}：1`
					}
				];
			}
			this.list.forEach((info, index) => {
				if (typeArr.indexOf(info.questionsTypeId) == -1) {
					let obj = {
						label: this.$functions.htmlFormat(info.questionsName),
						quesIndex: info.quesIndex != null  ? info.quesIndex + 1 : info.quesIndex,
						qid: info.qid,
						questionsTypeId: info.questionsTypeId,
					};
					if (this.data.length > 0) {
						this.data[this.data.length - 1].children.push(obj);
					}
				} else {
					let obj = {
						label: this.$functions.htmlFormat(info.questionsName),
						qid: info.qid,
						quesIndex: info.quesIndex != null ? info.quesIndex + 1 : info.quesIndex,
						questionsTypeId: info.questionsTypeId,
						children: []
					};
					this.data.push(obj);
				}
			});
			this.data = this.data.map((info, index) => {
				info.label = `${this.$t('main.pageNumber')}：${index + 1}`;
				return info;
			});
		},
		nodeClick(e) {
			let index = e.qid ? 0 : -1;
			this.$emit('goAnchor', `name${e.qid}`, e.qid, index);
		}
	}
};
</script>

<style lang="scss" scoped>
/deep/.el-tree-node__content {
	font-size: 14px;
}
.span-ellipsis {
	width: 80%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.icon-box {
	display: flex;
	justify-content: end;
	align-items: center;
	i {
		display: inline-block;
		font-size: 18px;
		color: #999;
		cursor: pointer;
		margin-left: 10px;
	}
}
.fixedSearch {
	margin-bottom: 10px;
}
.fixedTabsIcon-box {
	display: flex;
	justify-content: end;
	align-items: center;
	i {
		display: inline-block;
		font-size: 18px;
		color: #999;
		cursor: pointer;
		margin-left: 10px;
	}
}
// 大纲显示滚动条
.fixedTabsThird{
	width: 260px;
	height: calc(100vh - 200px);
	overflow-y: auto;
	z-index: 2;
	// padding-rigth:10px;k
	box-sizing: border-box;
	padding-bottom: 50px;
}
.fixedTabsThird::-webkit-scrollbar {
	// display: none;
}
</style>
